import { render } from "./NetworkError.vue?vue&type=template&id=2fbb842e"
const script = {}
script.render = render

export default script